import { get, post } from "../../../shared/data";

export const getBinHistory = (binId) => {
    return get(`/binmgt/bins/${binId}/tracks`);
};

export const changeBinLocation = (binId, locationCode) => {
    /*
    {
        "locationCode": "string"
    }
    */
    const payload = {
        locationCode: locationCode,
    };

    return post(`/binmgt/bins/${binId}/tracks`, payload, { passthrough: true });
};

export const getLocations = () => {
    return get("/binmgt/locations").then((locations) => {
        return locations.map((location) => {
            return {
                value: location.code,
                text: location.description,
            };
        });
    });
};
